import { Injectable } from '@angular/core';
import { InfillTypes, isLaserCutInfill } from '../../../../services/railing/infills/model/infill-types';
import { getLaserCutDesign } from '../../../../services/railing/infills/model/laser-cut-designs.config';


@Injectable()
export class GetQuoteInfoService {
  constructor() {}

  updateTopRailValue(topRail, topRailForStairs, topCapColor) {
    console.log('topRail', topRail);
    const lastTopRail = topRail;
    // const lastTopRail = topRail !== topRailForStairs ? topRailForStairs : topRail;
    let newTopRail = null;
    switch (lastTopRail) {
      case '150s':
        newTopRail = 'Graspable, series 150';
        break;
      case '100s':
        newTopRail = 'Square, series 100';
        break;
      case '300s':
        newTopRail = 'Round, series 300';
        break;
      case '200s':
        newTopRail = 'Rectangular, series 200';
        break;
      case '250s':
        newTopRail = 'Graspable, series 250';
        break;
      case '350s':
        newTopRail = 'Elliptical, series 350';
        break;
      case 'Low-Profile for Wood':
        newTopRail = `Low profile, series 450 (with cap), ${topCapColor}`;
        break;
      case '450sWithoutCap':
        newTopRail = 'Low profile, series 450 (no cap)';
        break;
      case 'al 150s':
        newTopRail = 'Aluminum, series 150 (between posts)';
        break;
      case 'Wood 2x4':
        newTopRail = 'Wood 2x4 (on top of posts)';
        break;
      case 'CompositeBetween':
        newTopRail = 'Composite (between posts)';
        break;
      case 'CompositeTop':
        newTopRail = 'Composite (on top of posts)';
        break;
      case 'Steel Flatbar':
        newTopRail = 'Steel flat bar';
        break;
      case 'Steel Tubular':
        newTopRail = 'Steel tubular round';
        break;
    }
    return newTopRail;
  }

  updateHandRailValue(handrail) {
    let newTopRail = null;
    switch (handrail) {
      case 'top150':
        newTopRail = 'Graspable, series 150';
        break;
      case 'appliedHandrail':
        newTopRail = 'Applied handrail';
        break;
    }
    return newTopRail;
  }

  getPostMount(mount) {
    let postMounting = null;
    switch (mount) {
      case 'Base Mount':
        postMounting = 'Surface Base';
        break;
      case 'Fascia Bracket Mount':
        postMounting = 'Fascia Bracket';
        break;
      case 'Fascia Mount':
        postMounting = 'Fascia';
        break;
      case 'Stantion Mount':
        postMounting = 'Stanchion';
        break;
      case 'Core Mount':
        postMounting = 'Inset';
        break;
    }
    return postMounting;
  }

  getDeckMatereal(mount) {
    let deckMaterial = null;
    switch (mount) {
      case 'wood-redWood':
        deckMaterial = 'Wood - redwood';
        break;
      case 'wood-ipe':
        deckMaterial = 'Wood - ipe';
        break;
      case 'wood-grey':
        deckMaterial = 'Wood - grey';
        break;
      case 'wood-cedar':
        deckMaterial = 'Wood - cedar';
        break;
      case 'tile-sand':
        deckMaterial = 'Tile - sand';
        break;
      case 'tile-grey':
        deckMaterial = 'Tile - grey';
        break;
      case 'concrete':
        deckMaterial = 'Concrete';
        break;
      case 'composite-redWood':
        deckMaterial = 'Composite - redwood';
        break;
      case 'composite-ipe':
        deckMaterial = 'Composite - ipe';
        break;
      case 'composite-grey':
        deckMaterial = 'Composite - grey';
        break;
      case 'composite-cedar':
        deckMaterial = 'Composite - cedar';
        break;
      case 'wood-pressure-treated':
        deckMaterial = 'Pressure-Treated Wood';
        break;
      case 'wood-thermally-modified':
        deckMaterial = 'Thermally Modified Wood';
        break;
      case 'composite-capped':
        deckMaterial = 'Capped Composite';
        break;
      case 'composite-traditional':
        deckMaterial = 'Traditional Composite';
        break;
      case 'pvc-grey':
        deckMaterial = 'PVC Decking';
        break;
      case 'aluminum-grey':
        deckMaterial = 'Aluminum Decking';
        break;
      case 'paver-porcelain':
        deckMaterial = 'Porcelain Pavers';
        break;
      case 'stone-natural':
        deckMaterial = 'Natural Stone';
        break;
      case 'deck-tiles':
        deckMaterial = 'Deck Tiles';
        break;
    }
    return deckMaterial;
  }

  updateInfillValue(infill, railingType?) {
    let newInfill = null;
    // the Modern kit rides the horizontalCable pipeline but quotes as its
    // own single infill option (spec p.8)
    if (railingType === 'Modern' && infill === 'horizontalCable') {
      return 'Modern';
    }
    if (isLaserCutInfill(infill)) {
      const design = getLaserCutDesign(infill);
      return design ? `Laser Cut ${design.quoteName}` : null;
    }
    switch (infill) {
      case 'verticalPicket':
        newInfill = 'Vertical Picket';
        break;
      case 'verticalCable':
        newInfill = 'Vertical Cable';
        break;
      case 'horizontalCableBaserail':
        newInfill = 'Horizontal Cable Base Rail';
        break;
      case 'horizontalCable':
        newInfill = 'Horizontal Cable';
        break;
      case InfillTypes.glassClear:
        newInfill = 'Glass Clear';
        break;
      case InfillTypes.glassSmoke:
        newInfill = 'Glass Smoke';
        break;
      case InfillTypes.glassDark:
        newInfill = 'Glass Dark';
        break;
      case InfillTypes.steelMeshAllure:
        newInfill = 'Steel Mesh Allure';
        break;
      case InfillTypes.steelMeshDazzle:
        newInfill = 'Steel Mesh Dazzle';
        break;
      case InfillTypes.steelMeshMetropolitan:
        newInfill = 'Steel Mesh Metropolitan';
        break;
      case InfillTypes.steelMeshHorizon:
        newInfill = 'Steel Mesh Horizon';
        break;
    }
    return newInfill;
  }

  getInfillColorByInfillStyleValue(infill) {
    let newInfill = null;
    if (isLaserCutInfill(infill)) {
      const design = getLaserCutDesign(infill);
      return design ? design.quoteName : null;
    }
    switch (infill) {
      case 'horizontalCableBaserail':
        newInfill = 'Stainless Steel';
        break;
      case 'horizontalCable':
        newInfill = 'Stainless Steel';
        break;
      case InfillTypes.glassClear:
        newInfill = 'Clear';
        break;
      case InfillTypes.glassSmoke:
        newInfill = 'Smoke';
        break;
      case InfillTypes.glassDark:
        newInfill = 'Dark';
        break;
      case InfillTypes.steelMeshAllure:
        newInfill = 'Allure';
        break;
      case InfillTypes.steelMeshDazzle:
        newInfill = 'Dazzle';
        break;
      case InfillTypes.steelMeshMetropolitan:
        newInfill = 'Metropolitan';
        break;
      case InfillTypes.steelMeshHorizon:
        newInfill = 'Horizon';
        break;
    }
    return newInfill;
  }

  getInfillTypeValue(infill) {
    let newInfill = null;
    if (isLaserCutInfill(infill)) {
      const design = getLaserCutDesign(infill);
      return design ? design.quoteName : null;
    }
    switch (infill) {
      case InfillTypes.glassClear:
        newInfill = 'Clear';
        break;
      case InfillTypes.glassSmoke:
        newInfill = 'Smoke';
        break;
      case InfillTypes.glassDark:
        newInfill = 'Dark';
        break;
      case InfillTypes.steelMeshAllure:
        newInfill = 'Allure';
        break;
      case InfillTypes.steelMeshDazzle:
        newInfill = 'Dazzle';
        break;
      case InfillTypes.steelMeshMetropolitan:
        newInfill = 'Metropolitan';
        break;
      case InfillTypes.steelMeshHorizon:
        newInfill = 'Horizon';
        break;
    }
    return newInfill;
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/services/get-quote-info.service.ts